import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { deleteContract } from '../data-provider';
import { CACHE_KEYS } from '../types';

export const useDeleteContract = ({ onSuccess }: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteContract(id),
    onError: () => {
      showNotification({
        message: 'An error has occurred. Please, try again',
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...CACHE_KEYS.all, 'contracts'] });
      showNotification({
        message: 'Successfully deleted the contract',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
      onSuccess?.();
    },
  });
};
